export const useMerchantStatus = () => {
  const { $api } = useNuxtApp();

  const acceptingOrders = ref<boolean>(true);
  const loading = ref(false);
  // Bug 9 fix: surface toggle API errors instead of swallowing them silently
  const toggleError = ref<string | null>(null);

  const fetchStatus = async (): Promise<void> => {
    try {
      const res = await $api<{ accepting_orders: boolean }>('merchant/status');
      acceptingOrders.value = res?.accepting_orders ?? true;
    } catch {
      // Default to accepting if fetch fails — don't block UI
      acceptingOrders.value = true;
    }
  };

  const toggleStatus = async (): Promise<void> => {
    loading.value = true;
    toggleError.value = null;
    try {
      const res = await $api<{ accepting_orders: boolean }>('merchant/status', {
        method: 'POST',
      });
      acceptingOrders.value = res?.accepting_orders ?? acceptingOrders.value;
    } catch {
      // Bug 9 fix: expose error so the UI can display feedback
      toggleError.value = 'Failed to update status — please try again';
    } finally {
      loading.value = false;
    }
  };

  return {
    acceptingOrders,
    loading,
    toggleError,
    fetchStatus,
    toggleStatus,
  };
};
